import { z } from 'zod';

// Contrato de las solicitudes de documento (G3-1, F1-23) validado con Zod (ENG-VAL-01):
// un drift del backend cae al estado de error de la query, no revienta en render. Los
// ids de BD llegan como texto (serializador de bigint).

export const REQUEST_STATUSES = ['pendiente', 'aprobada', 'rechazada', 'cancelada'] as const;
export type RequestStatus = (typeof REQUEST_STATUSES)[number];
export type RequestKind = 'nuevo' | 'modificacion';

const personSchema = z.object({ userId: z.string(), displayName: z.string().nullable() });

export const documentRequestSchema = z.object({
  id: z.string(),
  kind: z.enum(['nuevo', 'modificacion']),
  status: z.enum(REQUEST_STATUSES),
  documentType: z.object({ id: z.string(), name: z.string() }),
  processArea: z.object({ id: z.string(), name: z.string() }),
  proposedTitle: z.string(),
  reason: z.string(),
  owner: personSchema.nullable(),
  requester: personSchema,
  target: z.object({ id: z.string(), code: z.string(), title: z.string().nullable() }).nullable(),
  result: z.object({ id: z.string(), code: z.string() }).nullable(),
  createdAt: z.string(),
  resolvedAt: z.string().nullable(),
  resolver: personSchema.nullable(),
  resolutionNote: z.string().nullable(),
  /** Lo que el lector puede hacer con ella (lo decide el servidor). */
  canResolve: z.boolean(),
  canCancel: z.boolean(),
});
export type DocumentRequest = z.infer<typeof documentRequestSchema>;

const envelope = <T extends z.ZodType>(data: T) => z.object({ success: z.literal(true), data });

export const requestResponseSchema = envelope(documentRequestSchema);
export const requestListResponseSchema = z.object({
  success: z.literal(true),
  data: z.array(documentRequestSchema),
  meta: z.object({ total: z.number(), page: z.number(), pageSize: z.number() }),
});
export const summaryResponseSchema = envelope(z.object({ pending: z.number().int() }));

export interface RequestListParams {
  /** null = todas. */
  status: RequestStatus | null;
  mine: boolean;
  page: number;
}

export interface RequestPage {
  rows: DocumentRequest[];
  total: number;
}

export type CreateRequestInput =
  | {
      kind: 'nuevo';
      documentTypeId: string;
      processAreaId: string;
      proposedTitle: string;
      reason: string;
      ownerUserId?: string;
    }
  | { kind: 'modificacion'; targetEntryId: string; reason: string };

/** Correcciones de Calidad al aprobar; lo omitido queda como lo pidió el solicitante. */
export interface ApproveInput {
  documentTypeId?: string;
  processAreaId?: string;
  title?: string;
  code?: string;
  sapModule?: string;
  ownerUserId?: string | null;
}
